import type { JSX } from 'react';

import type { Replacements, TranslationKey } from '@change-corgi/core/i18n';

import { useI18n } from '../misc';

type Props = Readonly<{
	value: string;
	replacements?: Replacements;
}>;

export function Translate({ value, replacements }: Props): JSX.Element {
	const { translate } = useI18n();

	return <>{translate(value, replacements)}</>;
}

type TypedProps = Readonly<{
	value: TranslationKey;
	replacements?: Replacements;
}>;

export function TypedTranslate({ value, replacements }: TypedProps): JSX.Element {
	const { typedTranslate } = useI18n();

	return <>{typedTranslate(value, replacements)}</>;
}
